"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var SearchResultsMobile_1 = __importDefault(require("./SearchResultsMobile"));

var SearchResultsDesktop_1 = __importDefault(require("./SearchResultsDesktop"));

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var frontend_application_1 = require("@ryerson/frontend.application");

var DeliveryTimesRequestMapper_1 = require("../Header/Helpers/DeliveryTimesRequestMapper");

var frontend_common_2 = require("@ryerson/frontend.common");

var axios_1 = __importDefault(require("axios"));

var SearchResults = function SearchResults(_ref) {
  var onMoreProducts = _ref.onMoreProducts,
      results = _ref.results,
      isSticky = _ref.isSticky,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      itemRef = _ref.itemRef,
      storeDirectory = _ref.storeDirectory,
      setSearchText = _ref.setSearchText;

  var _a, _b, _c, _d, _e, _f, _g, _h; // PUB-SUB: Instantiated Subscribable , in this case calling it stateMessenger


  var _react_1$default$useS = react_1.default.useState(new frontend_common_1.Subscribable()),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 1),
      stateMessenger = _react_1$default$useS2[0];

  var _ref2 = (0, frontend_e_commerce_1.useEcommerce)(),
      defaultShipToAddress = _ref2.defaultShipToAddress,
      selectedShipToAddress = _ref2.selectedShipToAddress,
      customerPickup = _ref2.customerPickup,
      salesPlant = _ref2.salesPlant;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      axiosInstance = _ref3.axiosInstance,
      zipCode = _ref3.zipCode,
      profile = _ref3.profile,
      isLoggedIn = _ref3.user.isLoggedIn;

  var _react_1$default$useS3 = react_1.default.useState([]),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      deliveryTimes = _react_1$default$useS4[0],
      setDeliveryTimes = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(false),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      triggerDeliveryTimes = _react_1$default$useS6[0],
      setTriggerDeliveryTimes = _react_1$default$useS6[1];

  react_1.default.useEffect(function () {
    var _a;

    var unmounted = false;
    var cTokenSource = axios_1.default.CancelToken.source();
    var cTokenObject = {
      cancelToken: cTokenSource.token
    };

    if ((results === null || results === void 0 ? void 0 : results.matchingProducts) && (results === null || results === void 0 ? void 0 : results.matchingProducts.length) || ((_a = results === null || results === void 0 ? void 0 : results.recentlyPurchased) === null || _a === void 0 ? void 0 : _a.length)) {
      var allSearchResults = (results === null || results === void 0 ? void 0 : results.recentlyPurchased) && results.recentlyPurchased.length > 0 ? results === null || results === void 0 ? void 0 : results.matchingProducts.concat(results === null || results === void 0 ? void 0 : results.recentlyPurchased) : results === null || results === void 0 ? void 0 : results.matchingProducts;
      var itemsAvailabilityRequest = (0, DeliveryTimesRequestMapper_1.createItemsAvailabilityRequest)(allSearchResults || [], isLoggedIn, selectedShipToAddress ? selectedShipToAddress : defaultShipToAddress, defaultShipToAddress, customerPickup, salesPlant, zipCode, null, profile); // Delivery Times Success Handler

      var handleSuccess = function handleSuccess(response) {
        var responseData = response === null || response === void 0 ? void 0 : response.data;

        if (responseData) {
          !unmounted && setDeliveryTimes(responseData);
        } else {
          !unmounted && setDeliveryTimes([]);
        }
      }; //Error Callback


      var handleError = function handleError() {};

      (0, frontend_common_2.getDeliveryTimes)(itemsAvailabilityRequest, axiosInstance, handleSuccess, handleError, cTokenObject);
    }

    return function () {
      // cleanup api calls
      unmounted = true;
      cTokenSource.cancel("Cancelling in cleanup");
    };
  }, [results, triggerDeliveryTimes]);
  react_1.default.useEffect(function () {
    return function () {
      // cleanup unsubscribe to pubsub
      stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function () {
        return undefined;
      })();
    };
  }, []);
  return isMobile ? (0, jsx_runtime_1.jsx)(SearchResultsMobile_1.default, {
    articlesResources: (_a = results === null || results === void 0 ? void 0 : results.articlesResources) !== null && _a !== void 0 ? _a : [],
    matchingProducts: (_b = results === null || results === void 0 ? void 0 : results.matchingProducts) !== null && _b !== void 0 ? _b : [],
    megaMenuProducts: (_c = results === null || results === void 0 ? void 0 : results.megaMenuProducts) !== null && _c !== void 0 ? _c : [],
    recentlyPurchased: (_d = results === null || results === void 0 ? void 0 : results.recentlyPurchased) !== null && _d !== void 0 ? _d : [],
    onMoreProducts: onMoreProducts,
    storeDirectory: storeDirectory,
    deliveryTimes: deliveryTimes,
    setDeliveryTimes: setDeliveryTimes,
    setTriggerDeliveryTimes: setTriggerDeliveryTimes,
    stateMessenger: stateMessenger
  }) : (0, jsx_runtime_1.jsx)(SearchResultsDesktop_1.default, {
    isSticky: isSticky,
    onMoreProducts: onMoreProducts,
    itemRef: itemRef,
    storeDirectory: storeDirectory,
    articlesResources: (_e = results === null || results === void 0 ? void 0 : results.articlesResources) !== null && _e !== void 0 ? _e : [],
    matchingProducts: (_f = results === null || results === void 0 ? void 0 : results.matchingProducts) !== null && _f !== void 0 ? _f : [],
    recentlyPurchased: (_g = results === null || results === void 0 ? void 0 : results.recentlyPurchased) !== null && _g !== void 0 ? _g : [],
    megaMenuProducts: (_h = results === null || results === void 0 ? void 0 : results.megaMenuProducts) !== null && _h !== void 0 ? _h : [],
    deliveryTimes: deliveryTimes,
    setDeliveryTimes: setDeliveryTimes,
    setSearchText: setSearchText,
    setTriggerDeliveryTimes: setTriggerDeliveryTimes,
    stateMessenger: stateMessenger
  });
};

exports.default = SearchResults;